import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=7e20c0bc&scoped=true&"
import script from "./OrganizationPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=7e20c0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20c0bc",
  null
  
)

export default component.exports